import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from 'app/core/components/alert-dialog/alert-dialog.component';
import { FileService } from 'app/core/services/file.service';
import { DocumentRestService } from 'fitforce-document-sync';

@Injectable({
  providedIn: 'root',
})
export class PlaycardDownloadService {
  constructor(private fileService: FileService, private dialog: MatDialog, private restService: DocumentRestService) {}

  /**
   * Download the playcard's excel file.
   */
  download(planUUID: string, dayId: string, version: number) {
    this.restService.downloadPlaycard(planUUID, dayId, version).subscribe(taskUUID => {
      this.checkPlaycard(planUUID, dayId, version, taskUUID);
    });
  }

  checkPlaycard(planUUID: string, dayId: string, version: number, taskUUID: string) {
    return this.restService.checkPlaycardTask(taskUUID).subscribe((blob: Blob) => {
      const reader = new FileReader();
      reader.addEventListener('loadend', e => {
        const text = reader.result;
        // attempt to read the server response as a json
        const jsonResult = convertToJSON(text.toString());

        if (!jsonResult) {
          // if cannot convert to json, then it's a file and download it
          this.saveFile(blob, planUUID);
        } else {
          // if json, then it's a status message
          if (jsonResult.status === 'RETRY') {
            this.download(planUUID, dayId, version);
          } else if (jsonResult.status === 'FAILURE') {
            this.openDownloadErrorDialog();
          } else if (jsonResult.status === 'PENDING') {
            this.checkPlaycard(planUUID, dayId, version, taskUUID);
          }
        }
      });

      reader.readAsText(blob);
    });
  }

  /**
   * Open modal to alert user to a download failure.
   */
  openDownloadErrorDialog() {
    this.dialog.open(AlertDialogComponent, {
      data: { content: 'Could not download this day.' },
    });
  }

  /**
   * Download the blob in the browser.
   *
   * @param  {} data - blob data
   */
  saveFile(data, fileName?: string) {
    this.fileService.saveFile([data], `${fileName || 'blob'}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
  }
}

function convertToJSON(str: string) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return JSON.parse(str);
}
